import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import SpecialistDashboard from "../pages/CustomerSpecialist/Dashboard/SpecialistDashboard";
import Profile from "../pages/CustomerSpecialist/Profile/Profile";
import EditQuickInvoice from "../pages/CustomerSpecialist/QuickInvoices/EditQuickInvoice/EditQuickInvoice";
import QuickInvoice from "../pages/CustomerSpecialist/QuickInvoices/QuickInvoice/QuickInvoice";
import QuickInvoices from "../pages/CustomerSpecialist/QuickInvoices/QuickInvoices";

var CustomerSpecialistRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <SpecialistDashboard />,
    layout: "specialist",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },{
    path: "quick-invoices",
    name: "Quick Invoices",
    element: <QuickInvoices />,
    layout: "specialist",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
   {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "specialist",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "quick-invoices/create-quick-invoice",
    name: "Quick Invoice",
    element: <QuickInvoice />,
    layout: "specialist",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "quick-invoices/:id",
    name: "Edit Quick Invoice",
    element: <EditQuickInvoice />,
    layout: "specialist",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default CustomerSpecialistRoutes;
